import React, {useEffect, useState} from 'react';
import {Button, Card, Flex, Row, Typography} from 'antd';
import PaymentListView from './PaymentListView';
import PaymentDetailViewDialog from './PaymentDetailViewDialog';
import {useSelector} from 'react-redux';
import {SR_ACCEPTING_PAYMENTS, SR_STATUS, SR_TYPES} from 'Utils/constants/genericConstants';
import {Wrapper} from 'Components';

const Payment = (props, ref) => {
  const [openPaymentDetailViewDialog, isOenPaymentDetailViewDialog] = useState(false);
  const [disableMemberPayment, setDisableMemberPayment] = useState(true);
  const selectedSRData = useSelector((state: any) => state.selectedSR.getServiceRequestById);

  const [selectedPayment, setSelectedPayment]: any = useState({});

  useEffect(() => {
    setMemberPaymentButtonStatus();
  }, [selectedSRData]);

  const handlePaymentRowClick = (data) => {
    setSelectedPayment(data);
    isOenPaymentDetailViewDialog(true);
  };

  const handleNewPaymentClick = async () => {
    setSelectedPayment({});
    isOenPaymentDetailViewDialog(true);
  };

  const setMemberPaymentButtonStatus = () => {
    if (SR_ACCEPTING_PAYMENTS.includes(selectedSRData?.type)) {
      if (
        selectedSRData?.type === SR_TYPES.EVENT_BOOKING_CANCELLATION &&
        selectedSRData?.status === SR_STATUS.CLOSED
      ) {
        setDisableMemberPayment(true);
      } else {
        setDisableMemberPayment(false);
      }
    } else setDisableMemberPayment(true);
  };

  return (
    <Wrapper>
      <div ref={ref}>
        <Card style={{marginTop: 16, marginBottom: 16}}>
          <Flex vertical gap={16}>
            <Flex wrap justify="space-between" align="center" gap={8}>
              <Typography.Title level={4} style={{margin: 0}}>
                Payment Details
              </Typography.Title>
              <Button
                type="primary"
                onClick={handleNewPaymentClick}
                disabled={disableMemberPayment}
                style={{width: '15%'}}>
                New Payment
              </Button>
            </Flex>
            <Row gutter={4}>
              <PaymentListView handlePaymentRowClick={handlePaymentRowClick} />
            </Row>
            <PaymentDetailViewDialog
              openPaymentDetailViewDialog={openPaymentDetailViewDialog}
              isOenPaymentDetailViewDialog={isOenPaymentDetailViewDialog}
              selectedPayment={selectedPayment}
            />
          </Flex>
        </Card>
      </div>
    </Wrapper>
  );
};

export default React.forwardRef(Payment);
